import { render, staticRenderFns } from "./TextOverflow.vue?vue&type=template&id=5e0c620c&scoped=true&"
import script from "./TextOverflow.vue?vue&type=script&lang=js&"
export * from "./TextOverflow.vue?vue&type=script&lang=js&"
import style0 from "./TextOverflow.vue?vue&type=style&index=0&id=5e0c620c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c620c",
  null
  
)

export default component.exports